export default __webpack_public_path__ + "static/media/illus13.391e8714.png";